function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { logoutUser } from '@/actions/UserActions';
import AuthenticationStore from '@/stores/AuthenticationStore';
var RequestMethods;
(function(RequestMethods) {
    RequestMethods["GET"] = "GET";
    RequestMethods["POST"] = "POST";
    RequestMethods["PUT"] = "PUT";
    RequestMethods["DELETE"] = "DELETE";
    RequestMethods["PATCH"] = "PATCH";
})(RequestMethods || (RequestMethods = {}));
var _process_env_API_ENDPOINT;
var API_ENDPOINT = (_process_env_API_ENDPOINT = process.env.API_ENDPOINT) !== null && _process_env_API_ENDPOINT !== void 0 ? _process_env_API_ENDPOINT : 'https://api.nightbot.tv';
var _process_env_API_VERSION;
var API_VERSION = (_process_env_API_VERSION = process.env.API_VERSION) !== null && _process_env_API_VERSION !== void 0 ? _process_env_API_VERSION : '1';
export var HTTPError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(HTTPError, Error1);
    function HTTPError(message, statusCode, headers, body) {
        _class_call_check(this, HTTPError);
        var _this;
        _this = _call_super(this, HTTPError, [
            "[HTTPError] Status Code: ".concat(statusCode, ", Message: ").concat(message)
        ]), _define_property(_this, "statusCode", void 0), _define_property(_this, "headers", void 0), _define_property(_this, "body", void 0);
        _this.statusCode = statusCode !== null && statusCode !== void 0 ? statusCode : 0;
        _this.headers = headers !== null && headers !== void 0 ? headers : new Map();
        _this.body = body !== null && body !== void 0 ? body : null;
        return _this;
    }
    return HTTPError;
}(_wrap_native_super(Error));
function request(method, path) {
    return _request.apply(this, arguments);
}
function _request() {
    _request = _async_to_generator(function(method, path) {
        var requestOptions, body, _requestOptions_searchParams, searchParams, _requestOptions_withVersion, withVersion, requestHeaders, channelId, _requestOptions_retry, retry, options, url, filteredSearchParams, headers, accessToken;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestOptions = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    body = requestOptions.body, _requestOptions_searchParams = requestOptions.searchParams, searchParams = _requestOptions_searchParams === void 0 ? {} : _requestOptions_searchParams, _requestOptions_withVersion = requestOptions.withVersion, withVersion = _requestOptions_withVersion === void 0 ? true : _requestOptions_withVersion, requestHeaders = requestOptions.headers, channelId = requestOptions.channelId, _requestOptions_retry = requestOptions.retry, retry = _requestOptions_retry === void 0 ? true : _requestOptions_retry, options = _object_without_properties(requestOptions, [
                        "body",
                        "searchParams",
                        "withVersion",
                        "headers",
                        "channelId",
                        "retry"
                    ]);
                    url = null;
                    if (withVersion) {
                        url = new URL("".concat(API_VERSION).concat(path), API_ENDPOINT);
                    } else {
                        url = new URL(path, API_ENDPOINT);
                    }
                    if (searchParams != null) {
                        filteredSearchParams = Object.entries(searchParams).filter(function(param) {
                            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                            return value !== undefined;
                        });
                        url.search = new URLSearchParams(filteredSearchParams).toString();
                    }
                    headers = {};
                    accessToken = AuthenticationStore.getState().accessToken;
                    if (accessToken != null) {
                        headers.Authorization = "Session ".concat(accessToken);
                    }
                    if (channelId != null) {
                        headers['Nightbot-Channel'] = channelId;
                    }
                    if (body != null) {
                        headers['Content-Type'] = 'application/json';
                    }
                    return [
                        4,
                        fetch(url, _object_spread({
                            method: method,
                            headers: _object_spread({}, headers, requestHeaders),
                            body: body != null ? JSON.stringify(body) : undefined
                        }, options)).then(/*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(response) {
                                var data, _, body, message;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = null;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                response.json()
                                            ];
                                        case 2:
                                            data = _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            _ = _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            if (!response.ok) {
                                                body = data;
                                                message = body != null && 'message' in body ? body.message : response.statusText;
                                                throw new HTTPError(message, response.status, new Map(response.headers), body);
                                            }
                                            return [
                                                2,
                                                _object_spread_props(_object_spread({}, response), {
                                                    data: data
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(response) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(/*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(error) {
                                var httpError, _httpError_headers_get, retryAfter;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!_instanceof(error, HTTPError)) {
                                                error = new HTTPError(error.message);
                                            }
                                            httpError = error;
                                            if (!(retry && httpError.statusCode === 429)) return [
                                                3,
                                                3
                                            ];
                                            retryAfter = (_httpError_headers_get = httpError.headers.get('retry-after')) !== null && _httpError_headers_get !== void 0 ? _httpError_headers_get : '1';
                                            return [
                                                4,
                                                new Promise(function(resolve) {
                                                    return setTimeout(resolve, parseInt(retryAfter, 10) * 1000);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                request(method, path, requestOptions)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 3:
                                            if (httpError.statusCode === 401) {
                                                logoutUser();
                                            }
                                            return [
                                                4,
                                                Promise.reject(error)
                                            ];
                                        case 4:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _request.apply(this, arguments);
}
var API = {
    get: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(path, options) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request("GET", path, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(path, options) {
            return _ref.apply(this, arguments);
        };
    }(),
    post: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(path, options) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request("POST", path, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(path, options) {
            return _ref.apply(this, arguments);
        };
    }(),
    put: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(path, options) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request("PUT", path, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(path, options) {
            return _ref.apply(this, arguments);
        };
    }(),
    patch: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(path, options) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request("PATCH", path, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(path, options) {
            return _ref.apply(this, arguments);
        };
    }(),
    delete: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(path, options) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request("DELETE", path, options)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(path, options) {
            return _ref.apply(this, arguments);
        };
    }()
};
export default API;
